import React from "react";
import cardButtonIconStyles from "../styles/CardButtonIcon.styles";

const CardButtonIcon = ({ iconName, inline }) => {
	const classes = cardButtonIconStyles({ iconName });
	return <span className={inline ? classes.inlineIcon : classes.icon} />;
};

export default CardButtonIcon;
